import { useEffect, useState } from "react";

import { FetchStatus } from "../../../../base/types";
import { IAsyncBoundProperties } from "../../../../base/hooks";
import { IOtpVerificationProps } from "./IOtpVerificationProps";

export const OtpVerificationProperties = []

export const useOtpVerification = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IOtpVerificationProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        setProperties({})
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}

